import React, { useEffect, useState } from 'react';
import B2BService from '../../API/B2BService';
import cl from './Cabinet.module.css';

/**
 * «Заявки и счета» — что владелец у нас запрашивал и что ему выставили.
 *
 * До этого узнать судьбу своей заявки можно было только в переписке: она
 * уходила в админку и для владельца исчезала.
 */

const REQUEST_KIND = {
    invoice: 'Счёт на оплату',
    callback: 'Обратный звонок',
};

const REQUEST_STATUS = {
    new: ['Новая', cl.stNew],
    in_progress: ['В работе', cl.stWork],
    done: ['Обработана', cl.stDone],
    cancelled: ['Отменена', cl.stDead],
};

const INVOICE_STATUS = {
    issued: ['Ожидает оплаты', cl.stWork],
    paid: ['Оплачен', cl.stDone],
    cancelled: ['Аннулирован', cl.stDead],
};

function fmtDate(ms) {
    if (!ms) return '';
    return new Date(Number(ms)).toLocaleDateString('ru-RU', {
        day: 'numeric', month: 'long', year: 'numeric',
    });
}

// Суммы в БД лежат в копейках — как и везде в платежах.
function fmtAmount(kopecks) {
    if (!kopecks && kopecks !== 0) return '';
    return (kopecks / 100).toLocaleString('ru-RU') + ' ₽';
}

export default function HistoryBlock() {
    const [requests, setRequests] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        Promise.all([B2BService.getMyRequests(), B2BService.getMyInvoices()])
            .then(([r, i]) => {
                if (!alive) return;
                setRequests(r);
                setInvoices(i);
                setLoading(false);
            });
        return () => { alive = false; };
    }, []);

    // Пока ничего не запрашивали — не показываем пустую таблицу с заголовком,
    // она только занимает место в кабинете.
    if (loading || (!requests.length && !invoices.length)) return null;

    return (
        <div className={cl.historyGrid}>
            {invoices.length > 0 && (
                <div className={cl.detailsCard}>
                    <div className={cl.detailsHead}>
                        <h3 className={cl.detailsTitle}>Счета</h3>
                    </div>
                    <div className={cl.historyList}>
                        {invoices.map(inv => {
                            const [label, cls] = INVOICE_STATUS[inv.status]
                                || [inv.status, cl.stNew];
                            return (
                                <div key={inv.id} className={cl.historyRow}>
                                    <div className={cl.historyMain}>
                                        <span className={cl.historyTitle}>
                                            {inv.number || `Счёт №${inv.id}`}
                                        </span>
                                        <span className={cl.historyMeta}>
                                            {fmtDate(inv.issued_at)}
                                            {inv.due_at && inv.status === 'issued'
                                                && <> · оплатить до {fmtDate(inv.due_at)}</>}
                                            {inv.paid_at && <> · оплачен {fmtDate(inv.paid_at)}</>}
                                        </span>
                                    </div>
                                    <div className={cl.historySide}>
                                        <span className={cl.historyAmount}>
                                            {fmtAmount(inv.amount)}
                                        </span>
                                        <span className={`${cl.badge} ${cls}`}>{label}</span>
                                    </div>
                                    {inv.pdf_url && (
                                        <a className={cl.historyLink} href={inv.pdf_url}
                                            target="_blank" rel="noopener noreferrer">Скачать PDF</a>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {requests.length > 0 && (
                <div className={cl.detailsCard}>
                    <div className={cl.detailsHead}>
                        <h3 className={cl.detailsTitle}>Мои заявки</h3>
                    </div>
                    <div className={cl.historyList}>
                        {requests.map(req => {
                            const [label, cls] = REQUEST_STATUS[req.status]
                                || [req.status, cl.stNew];
                            const topic = req.payload?.topic;
                            return (
                                <div key={req.id} className={cl.historyRow}>
                                    <div className={cl.historyMain}>
                                        <span className={cl.historyTitle}>
                                            {REQUEST_KIND[req.kind] || req.kind}
                                            {topic && <> · {topic}</>}
                                        </span>
                                        <span className={cl.historyMeta}>
                                            {fmtDate(req.created_at)}
                                        </span>
                                    </div>
                                    <div className={cl.historySide}>
                                        <span className={`${cl.badge} ${cls}`}>{label}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
